module.exports = __webpack_public_path__ + "assets/img/detail5.a9a84c53.png";